var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#E2F5F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4336_52654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 22.252V24.342C21.0949 24.022 20.1263 23.9239 19.1754 24.0558C18.2245 24.1877 17.3192 24.5459 16.5354 25.1002C15.7517 25.6545 15.1123 26.3888 14.6712 27.2414C14.23 28.094 13.9998 29.04 14 30L12 29.999C11.9997 28.7779 12.2789 27.5729 12.8163 26.4764C13.3537 25.3799 14.1349 24.4209 15.1002 23.673C16.0655 22.9251 17.1892 22.4081 18.3852 22.1616C19.5811 21.9152 20.8177 21.9457 22 22.251V22.252ZM20 21C16.685 21 14 18.315 14 15C14 11.685 16.685 9 20 9C23.315 9 26 11.685 26 15C26 18.315 23.315 21 20 21ZM20 19C22.21 19 24 17.21 24 15C24 12.79 22.21 11 20 11C17.79 11 16 12.79 16 15C16 17.21 17.79 19 20 19ZM25.793 27.914L29.328 24.379L30.743 25.793L25.793 30.743L22.257 27.207L23.672 25.793L25.792 27.914H25.793Z",
    fill: "#6FCBD4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4336_52654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGreen);
export default __webpack_public_path__ + "static/media/user_green.d893f881416f59a751baa533f0798561.svg";
export { ForwardRef as ReactComponent };